import React, { Component } from 'react'
import {
	Col,
	FormGroup,
	Button
} from "react-bootstrap";
import moment from 'moment'
import {   reduxForm, propTypes,formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import {
	uploadFileRules,
	uploadingRulesFile,
	resetWizardState,
	prestineNavigateNext,
} from "../../../../redux/actions/action_event"
import {  forms,blue,videoblue, gray, warning, StatusDescription } from "../../../../utils/constants"
import { STEP_SEQUENCE } from '../../logic';

const FormName = forms.eventinfo
const fileInputStyle = {
	maxWidth:'230px',
	borderRadius:'0',
	fontSize:'14px',
	padding:'5px',
	color:blue ,
	maxHeight:'32px',
	fontWeight:'bold',
}

class EventRules extends Component {
 
	static propTypes = {
		...propTypes
	}
	constructor(props)
	{  
		super(props)
		this.state = {
			rulesFile:'',
		}
		this.uploadEventRules = this.uploadEventRules.bind(this);
		this.handleOnFileChange = this.handleOnFileChange.bind(this);
		this.handleSaveTemplate = this.handleSaveTemplate.bind(this);
		this.setComponentState  = this.setComponentState.bind(this);
	}
	componentDidMount(){
		window.scrollTo(0, 0)
		this.props.dispatch(resetWizardState(STEP_SEQUENCE.Rules));
	}
	uploadEventRules() {
    if(this.props.currentWizardStep !== STEP_SEQUENCE.UploadFinalStandings)
		{
			const { eventId } = this.props;
			const rulesfile = this.uploadInput.files[0];
			const formData = new FormData();

			formData.append('eventId',eventId);
			formData.append('rulesfile', rulesfile);

			if(rulesfile !== undefined){
				this.props.dispatch(uploadingRulesFile());
				this.props.dispatch(uploadFileRules(formData));
			}
		}
		else
		{
			this.props.dispatch(prestineNavigateNext());
		}
	}
	setComponentState(rulesUploaded)
	{
		if(rulesUploaded)
		{
			this.props.dispatch(prestineNavigateNext());
		}
	}
	handleSaveTemplate(e)
	{
		e.preventDefault();
		this.uploadEventRules();
	}   

	handleOnFileChange()
    {
			const fileSelected = this.uploadInput.files[0] ? true:false
			const rulesFile =  fileSelected == true ? this.uploadInput.files[0].name:''
			this.setState({ 
				rulesFile,
			}) 
    }

	render() {
		const { rulesFile } = this.state
		const {
			uploadingRules,
		} = this.props;

		const rulesSelected = ((rulesFile == undefined) || (rulesFile.length == 0)) ? false:true
		const fileMessage = rulesSelected == true ? rulesFile:'No file selected.'
		const fileMessageColor = rulesSelected  == true? videoblue:warning
		const uploadingIcon = uploadingRules === true  ? "fa fa-spinner fa-spin":"fa fa-upload"
		const rulesFileMissing = rulesFile === '' || rulesFile === undefined

		const {  eventname,
			rulesUploadedOn,
			saveComponentState,
			componentStateSaved,
			currentWizardStep,
            roleName,
            status
	} = this.props;

    const isAdministrator = roleName == 'Administrator';
	const rulesUploaded = (rulesUploadedOn !== null) && (rulesUploadedOn !== undefined);

	if(currentWizardStep === STEP_SEQUENCE.Rules)
	{      
		if((saveComponentState === true) && (componentStateSaved === false))
		{
			this.uploadEventRules();
		} 
		if(componentStateSaved === true)
		{
			this.props.onComponentStateSaved(componentStateSaved)
		}
		if(!rulesUploaded)
		{
			this.props.onComponentStateSaved(false)
		}
	}
	
	return (
		<div style={{ marginTop:'1%' }} sm={6}>
			{
				(
					<Col sm={12} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px' }} >
						<FormGroup style={{ padding:'0 0 15px 25px', margin:'0' }}>
							<h4 className='text-left'  style={{ color:blue }}>{' '}Event Name - {eventname}</h4>
							<br />
							<form id='eventinfo' encType="multipart/form-data" onSubmit={this.handleSaveTemplate} role="form" className="form-inline" style={{ margin:'-15px 0' }}>
                                <label className="btn btn-default" style={fileInputStyle} disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} >
									<i className="fa fa-file" aria-hidden="true" />&nbsp;{' '}Select Event Rules File  {' '}
                             <input type='file' accept=".*" id="rulefile" ref={(ref) => { this.uploadInput = ref; }} style={{ display: 'none', marginTop: '20px' }} onChange={this.handleOnFileChange}
                                 disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} />                        
								</label>
								<Button  onClick={this.handleSaveTemplate} style={{ ...fileInputStyle, margin:'0 2px',  }} disabled={ rulesFileMissing }>
									<i className={uploadingIcon} aria-hidden="true" />&nbsp;&nbsp;Upload Event Rules
								</Button>
								<label style={{ minWidth:'240px',color:fileMessageColor,fontWeight:'bold' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										{fileMessage}
								</label><br />
								<br />
								{ 
									rulesUploaded &&
									(<span style={{ fontSize:'14px', fontWeight:'bold' }}>
										<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;Event rules uploaded on&nbsp; {moment(rulesUploadedOn, 'YYYY-MM-DD').format('LL')}.
									</span>)
								} 
							</form>			
								{
									!rulesUploaded && (<span>
									<h5 className='text-left'  style={{ color:warning, marginTop:'15px' }}><i className="fa fa-exclamation-triangle" />You have not submitted your event rules yet. You can upload them in any file format.</h5>
									<h5 className='text-left'  style={{ color:warning, marginTop:'15px' }}><i className="fa fa-exclamation-triangle" />For multiple pages, you must select and upload each file/page individually.</h5></span>)
								}
						</FormGroup>
									
					</Col>		
				)
			} 
		</div>)
	}
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const eventId               = selector(state,'eventId')
	const eventname             = selector(state,'eventname')
	const rulesApproved   = selector(state,'rulesApproved')
	const rulesApprovedOn   = selector(state,'rulesApprovedOn')
	const rulesUploadedOn   = selector(state,'rulesUploadedOn')
	const savingData            = selector(state,'savingData')
	const componentStateSaved = selector(state,'componentStateSaved')
	const currentWizardStep = selector(state,'currentWizardStep')
	const uploadingRules = selector(state,'uploadingRules');
	const successfileUpload = selector(state,'successfileUpload');
    const roleName = state.user.roleName
    const status = selector(state, 'status')
  return {
		eventname,
		eventId,
		rulesApproved,
		rulesApprovedOn,
		rulesUploadedOn,
		savingData,
		user:state.user,
		uploadingRules,
		successfileUpload,
		componentStateSaved,
		currentWizardStep,
        roleName,
        status
	}
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		uploadFileRules,
		uploadingRulesFile,
		resetWizardState,
		prestineNavigateNext,
	},dispatch)
}
EventRules.propTypes = {
	handleSubmit:PropTypes.func,
	previousPage:PropTypes.func,
	dispatch:PropTypes.func,
	eventId:PropTypes.number,
	eventname:PropTypes.string,
	rulesApproved:PropTypes.bool,
	rulesApprovedOn: PropTypes.string,
	rulesUploadedOn: PropTypes.string,
	eventtype:PropTypes.string,
	savingData:PropTypes.bool,
	user:PropTypes.object,
	uploadingRules:PropTypes.bool,
	successfileUpload:PropTypes.bool,
	onComponentStateSaved: PropTypes.func,
	componentStateSaved: PropTypes.bool,
	saveComponentState:PropTypes.bool,
	currentWizardStep: PropTypes.number,
    roleName: PropTypes.string,
    status: PropTypes.string
}
export default reduxForm({
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventRules))
    



// WEBPACK FOOTER //
// ./src/containers/event/components/rules/index.js